<template>
  <div id="homeContainer">
    <router-link
      id="profitswordClients"
      to="/admin/PsClientAdmin"
      class="link"
    >
      <div class="statWrapper">
        <div class="statTitle">
          Profitsword Clients
        </div>
        <div class="statData">
          {{ numberOfClients }}
        </div>
      </div>
    </router-link>
    <router-link
      id="clientUsers"
      to="/admin/UserAdmin"
      class="link"
    >
      <div class="statWrapper">
        <div class="statTitle">
          Client Users
        </div>
        <div class="statData">
          {{ numberOfUsers }}
        </div>
      </div>
    </router-link> 
    <router-link
      id="profitswordUsers"
      to="/admin/UserAdmin"
      class="link"
    >
      <div class="statWrapper">
        <div class="statTitle">
          Profitsword Users
        </div>
        <div class="statData">
          {{ numberOfPSUsers }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            numberOfClients: 0,
            numberOfUsers: 0,
            numberOfPSUsers: 0,

            numberOfClientsOptions: {
                cellClick: (e, cell) => {
                    this.$router.push("/admin/PsClientAdmin");
                    //alert('clicked!');
                },
                resizableColumns: false,
                movableColumns: false,
                columns: [
                    {
                        title: "",
                        field: "numberOfClients",
                        width: 245,
                        height: 100,
                    },
                ],
            },

            numberOfUsersOptions: {
                cellClick: (e, cell) => {
                    this.$router.push("/admin/UserAdmin");
                    //alert('clicked!');
                },
                resizableColumns: false,
                movableColumns: false,
                columns: [
                    {
                        title: "",
                        field: "numberOfUsers",
                        width: 245,
                        height: 100,
                    },
                ],
            },
        };
    },
    created() {
        this.GetUsageStatistics();
    },
    methods: {
        async GetUsageStatistics() {
            axios
                .get(localConfig.authenticationURL + "/api/UsageStats", null)
                .then((response) => {
                    this.numberOfClients = response.data["psClientCount"];
                    this.numberOfPSUsers = response.data["profitSwordUserCount"];
                    this.numberOfUsers = response.data["userCount"];
                })
                .catch((error) => {
                    localStorage.removeItem("token");
                    localStorage.removeItem("refresh_token");
                    //context.commit("authError");
                    console.log(error);
                    reject(error);
                });
        },
    },
};
</script>

<style lang="scss">
@import '../styles/_color-variables.scss';
div#homeContainer {
  height: calc(100vh - 60px);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;

  a#profitswordClients { 
    grid-column: 1;
    grid-row: 2;
    justify-self: end;
  }

  a#clientUsers { 
    grid-column: 2;
    grid-row: 2;
    justify-self: center;
  }

  a#profitswordUsers { 
    grid-column: 3;
    grid-row: 2;
    justify-self: start;
  }

  a.link {
    text-decoration: none;
    width: 300px;
    height: 150px;
    cursor: pointer;

    div.statWrapper {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 20px;
      box-shadow: 1px 1px 5px #0003;
      border: 1px solid #d7d7d7;
      padding: 0 20px;

      div.statTitle {
        height: 50px;
        width: 100%;
        font-size: 24px;
        padding: 10px 20px;
        color: #08144f;
        text-align: center;
        border-bottom: 1px solid #d7d7d7;
      }

      div.statData {
        height: 100px;
        width: 100%;
        font-size: 70px;
        text-align: center;
        text-decoration: underline;
        color: $adminColor1;
      }
    }
  } 
}

div.tableContainer {
  background-color: border;
}
</style>
